import { IPassportGroup } from '@/pages/MDM/mdm.types'
import useTreeSelectCtrl from '@/shared/Tree/ctrl/useTreeSelectCtrl'
import domUtils from '@/utils/dom.utils'
import { MutableRefObject } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

interface IProps {
  treeKey: string
  tableRef: MutableRefObject<HTMLDivElement>
  isGroupIdPushedToUrlHash?: boolean
}

const useEquipmentPassportTreeCtrl = (props: IProps) => {
  const groupSelectCtrl = useTreeSelectCtrl<IPassportGroup['id']>(props.treeKey, null, 'regularState')
  const location = useLocation()
  const navigate = useNavigate()

  const pushGroupIdToUrlHash = (groupId: IPassportGroup['id']) => {
    location.hash = `#group-${groupId}`
    navigate(location, { replace: true })
  }

  const handleGroupSelect = (groupId: IPassportGroup['id']) => {
    const targetElement = props.tableRef.current?.querySelector(`#groupId_${groupId}`) as HTMLElement
    domUtils.scrollToTargetElement(targetElement)
    groupSelectCtrl.handleSelect(groupId)
  }

  const onGroupIntoViewportChange = (activeGroupId: IPassportGroup['id']) => {
    groupSelectCtrl.handleSelect(activeGroupId)
    if (!props.isGroupIdPushedToUrlHash) return
    pushGroupIdToUrlHash(activeGroupId)
  }

  return {
    handleGroupSelect,
    onGroupIntoViewportChange,
    groupSelectCtrl,
  }
}

export default useEquipmentPassportTreeCtrl
